import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { SSelect } from '@avalara/skylab-sdk/react';
import { selectState } from '../../../selectors';
import { setMarketingDataField } from '../../../store/data';
const ConnectorSelect = () => {
    const dispatch = useDispatch();
    const { data: { marketingData, connectors } } = useSelector(selectState);
    const defaultOption = {
        label: 'Select which integration you use',
        value: '',
    };
    const formattedConnectors = [defaultOption].concat(connectors.data.map(({ name, id }) => ({ label: name, value: id, selected: marketingData.connector === id })));
    return (React.createElement("fieldset", null,
        React.createElement(SSelect, { "data-ref": 'risk-assessment.connector-select', id: 'connector-select', inputId: 'connector-select', optionsList: formattedConnectors, "onS-select": e => dispatch(setMarketingDataField({ field: 'connector', data: e.detail.item.value })) })));
};
export default ConnectorSelect;
